import * as yup from 'yup'
export const editCitySchema = yup.object().shape({
    name: yup.string().required('من فضلك ادخل اسم المدينة '),
    is_disabled: yup.boolean(),
})
